import { useMemo } from 'react';
// Components
import { MenuItem, Stack, Typography } from '@mui/material';
import {
  RHFMultiSelect,
  RHFSearchableMultiSelect,
  RHFSelect,
  RHFTextField,
} from '@Components/hook-form';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';

// Styles
import Styles from './CreateRoleContent.module.scss';
import {
  useGetProvidersQuery,
  useGetRolesQuery,
  useGetProvidersFromAllRgsQuery,
} from '@Src/generated.graphql';
import { useCreateAviatorUserForm } from '@Forms/aviatorRoles/CreateAviatorUserFormContext';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

const useDropDown = () => {
  const { data: providersData } = useGetProvidersQuery();
  const { data: rolesData } = useGetRolesQuery();
  const { data: providersWithRgs } = useGetProvidersFromAllRgsQuery();

  const roleDropdown = useMemo(
    () =>
      rolesData?.roles?.map(({ name, id }) => (
        <MenuItemEx key={id} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [rolesData]
  );
  const roleOptions = useMemo(
    () =>
      rolesData?.roles?.map(({ name, id }) => ({
        label: name,
        value: id,
      })) || [],
    [rolesData]
  );
  const providersDropdown = useMemo(
    () =>
      providersData?.providers?.map(({ name, id }) => (
        <MenuItemEx key={name} value={id} name="Users">
          {name}
        </MenuItemEx>
      )),
    [providersData]
  );

  const providersWithRgsDropdown = useMemo(
    () =>
      providersWithRgs?.providersFromAllRGS?.map(({ providerId, providerName, rgsId }) => (
        <MenuItemEx key={providerId} value={providerId} name="ProvidersWithRgs">
          {`${providerName}(${rgsId.slice(-2)})`}
        </MenuItemEx>
      )),
    [providersWithRgs]
  );
  return {
    roles: roleDropdown,
    roleOptions,
    providers: providersDropdown,
    providersWithRgs: providersWithRgsDropdown,
  };
};

export const CreateUserContent = () => {
  const { currentUser } = useAuthorization();
  const dropdown = useDropDown();
  const { data } = useGetProvidersFromAllRgsQuery();
  const methods = useCreateAviatorUserForm();
  const isSuper = currentUser?.isSuper;

  return (
    <Stack className={Styles.CreateRoleContent}>
      {isSuper && (
        <RHFSelect label="Is Provider Users Admin" name="isProviderUsersAdmin" variant="outlined">
          <MenuItem value="true">True</MenuItem>
          <MenuItem value="false">False</MenuItem>
        </RHFSelect>
      )}
      {isSuper && (
        <RHFMultiSelect
          name="allowedRoleIds"
          label="Allowed role ids"
          variant="outlined"
          chip
          options={dropdown.roleOptions}
          disabled={methods.watch('isProviderUsersAdmin') === 'false'}
        ></RHFMultiSelect>
      )}
      <RHFTextField name="email" label="Email" type="email" />
      <RHFTextField name="password" label="Password" />
      <Stack className={Styles.PasswordRecuirements}>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Length: min - 8, recommended - 14
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Complexity: min - 1 uppercase, 1 lowercase, 1 number, 1 symbol
        </Typography>
        <Typography variant="caption" sx={{ color: 'grey' }}>
          Disallowed pattern: Username
        </Typography>
      </Stack>
      {/* <RHFSelect label="Provider" name="providerId" variant="outlined">
        {dropdown.providers}
      </RHFSelect> */}
      <RHFSelect label="Role" name="roleIds" variant="outlined">
        {dropdown.roles}
      </RHFSelect>
      <RHFSearchableMultiSelect name="providerRgs" providers={data?.providersFromAllRGS || []} />
      {/* <RHFSelect label="Provider" name="providerRgs">
        {dropdown.providersWithRgs}
      </RHFSelect> */}
      {/* <RHFSearchableSelect label="Provider" name="providerId" options={transformedData ?? []} /> */}
    </Stack>
  );
};
